export interface AuraInsight {
    type: 'positive' | 'negative' | 'neutral' | 'warning';
    text: string;
    confidence?: number;
}
